import {OtherPyroProductsThanClinkerClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

const fields = [{key: OtherPyroProductsThanClinkerClassificationInputNames.Category}]

export const OtherPyroProductsThanClinkerClassificationHeader = () => {
  return (
    <ClassificationHeaderCells
      fields={fields}
      materialType={MaterialType.OtherPyroProductsThanClinker}
    />
  )
}
